import React, { useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import zoomPlugin from 'chartjs-plugin-zoom';
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin,
);

const options = {
  responsive: true,
  scales: {
    x: {
      ticks: {
        font: {
          family: "Prompt",
          size: 16,
        },
      },
    },
    y: {
      title: {
        display: true,
        text: "จำนวนคน",
        font: {
          family: "Prompt",
          size: 16,
        },
      },
      ticks: {
        font: {
          family: "Prompt",
          size: 16,
        },
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    zoom: {
      zoom: {
        wheel: {
          enabled: true,
        },
        pinch: {
          enabled: true,
        },
        drag: {
          enabled: true,
        },
        mode: "x",
      },
    },
  },
};

function VerticalBarChart({ data }) {
  const chartData = {
    labels: data.map((item) => item.name),
    datasets: [
      {
        label: "จำนวน",
        data: data.map((item) => item.staff_amount),
        backgroundColor: "#e7e5fd",
      },
      {
        label: "จำนวน",
        data: data.map((item) => item.patient_amount),
        backgroundColor: "#d4f7fc",
      },
      {
        label: "จำนวน",
        data: data.map((item) => item.lab_amount),
        backgroundColor: "#daf6e6",
      },
    ],
  };
  return <Bar options={options} data={chartData} />;
}

export default VerticalBarChart;